import React, { useRef, useState } from 'react';
import cn from 'classnames';
import styles from '../gallery.module.scss';
import ImageWithPlaceholder from '../../ui/ImageWithPlaceholder';

const SingleImage = ({ onClick, src }) => {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const blockRef = useRef(null);
    return (
        <div className={cn(styles.gridItem, styles[`image-1-1`])} onClick={onClick} ref={blockRef}>
            {isImageLoaded && <div className={styles.blur} style={{ backgroundImage: isImageLoaded ? `url("${src}")` : '' }} />}
            <ImageWithPlaceholder src={src} setIsImageLoaded={setIsImageLoaded} />
        </div>
    );
};

export default SingleImage;
